import React, { useState } from 'react'
import { FormCarrozzerieModal } from '@next-nx/shared-ui/organisms'

interface Props {
  pagina?: any
  variant: 'login' | 'recupera_password' | 'ripristina_password' | 'success'
  token?: string
  setToken?: any
}

const AccessoLandingCarrozzerieTemplate = (props: Props) => {
  const { pagina = {}, variant = 'login', token = '', setToken = undefined } = props

  const [type, setType] = useState(variant)

  return (
    <FormCarrozzerieModal
      variant={type}
      token={token}
      onChangeVariant={setType}
      setToken={setToken}
    />
  )
}

export default AccessoLandingCarrozzerieTemplate
